import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Grid } from '@alfa-bank/site-grid-universal';

import type { IStickyTableRowDeps, IStickyTableRowProps } from '../models';

import { StickyTableRow as Component } from './sticky-table-row';

export const StickyTableRow = createWidget<IStickyTableRowDeps, IStickyTableRowProps>({
    Grid,
})(Component);
